<!-- 小箱装大箱管理 -->
<template>
    <div class="container">
        <div class="header">
            <Input class="w300 mr-24 mb-24" type="text" v-model="storePrams.qrcode_number" placeholder="请输入或扫描产品溯源码编码查询外箱"></Input>
            <Input class="w200 mr-24 mb-24" type="text" v-model="storePrams.big_box_number" placeholder="请输入或扫描大箱码查询"></Input>
            <Input class="w200 mr-24 mb-24" type="text" v-model="storePrams.small_box_number" placeholder="请输入箱内小箱码编码"></Input>
            <Select class="w200 mr-24 mb-24" v-model="storePrams.batch_id" clearable filterable placeholder="请选择关联批次">
                <Option v-for="item in batchList" :value="item.id" :key="item.id">{{ item.batch_name }}</Option>
            </Select>
            <Select class="w200 mr-24 mb-24" v-model="storePrams.product_id" clearable filterable placeholder="请选择关联产品">
                <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.product_name }}</Option>
            </Select>
            <Button class="theme-bg mb-24" icon="ios-search" type="warning" @click="goSearch">确定搜索</Button>
        </div>
        <div class="content">
            <div>
                <Button class="theme-bg mr-24 mb-24" type="warning" @click="goPacking">小箱装入大箱</Button>
                <Button class="mr-24 mb-24" type="warning" ghost @click="goRepair">补充小箱到大箱</Button>
                <Button class="mr-24 mb-24" type="warning" ghost  @click="goUnpacking">拆码出箱（拆大箱操作）</Button>
                <Table ref="selection" :columns="columnsTable" :data="dataTable" border @on-selection-change="changeSelection">
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="small_num">
                        <div><Button @click="goDetails(row)">{{row.small_num}}</Button></div>
                    </template>
                    <template slot-scope="{ row }" slot="product_nums">
                        <div>{{row.product_nums}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="success" ghost label="small" @click="goProduct(row)">详情</Button>
                            <Button type="error" ghost label="small" @click="goDel(1, row)">删除</Button>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <div>
                    <Checkbox class="checkbox-ml" v-model="del_value" @on-change="handleSelectAll">全选</Checkbox>
                    <span class="mr-24 ml-24">已经选择{{delData.length}}个</span>
                    <Button type="error" ghost label="large" @click="goDel(0)">删除</Button>
                </div>
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
        <!-- 大箱中小箱列表 -->
        <Drawer v-model="detailsDrawer" :title="detailsTitle" width="80">
            <Table :columns="columnsDetails" :data="dataDetails" border>
                <template slot-scope="{ index }" slot="id">
                    <div>{{ index + 1 }}</div>
                </template>
                <template slot-scope="{ row }" slot="small_box_number">
                    <div>{{row.small_box_number}}</div>
                </template>
                <template slot-scope="{ row }" slot="count">
                    <div><Button type="error" ghost label="small">{{row.count ? row.count : 0}}</Button></div>
                </template>
            </Table>
            <div class="page_drawer">
                <Page :current="pageDetails.page" :page-size="pageDetails.limit" :total="totalDetails" show-elevator show-total @on-change="changeDetails"/>
            </div>
        </Drawer>
        <!-- 大箱中产品列表 -->
        <Drawer v-model="productDrawer" :title="productTitle" width="80">
            <Table :columns="columnsProduct" :data="dataProduct" border>
                <template slot-scope="{ index }" slot="id">
                    <div>{{ index + 1 }}</div>
                </template>
                <template slot-scope="{ row }" slot="show_product_imgs">
                    <div class="flex-c">
                        <img class="table_img" v-if="row.product_qrcode" :src="row.product_qrcode.product.show_product_imgs[0]">
                        <img class="table_img" v-else src="../../assets/example1.png">
                    </div>
                </template>
                <template slot-scope="{ row }" slot="product_name">
                    <div>{{row.product_qrcode ? row.product_qrcode.product.product_name : ''}}</div>
                </template>
                <template slot-scope="{ row }" slot="specs">
                    <div>{{row.product_qrcode ? row.product_qrcode.product.specs : ''}}</div>
                </template>
            </Table>
            <div class="page_drawer">
                <Page :current="pageProduct.page" :page-size="pageProduct.limit" :total="totalProduct" show-elevator show-total @on-change="changeProduct" />
            </div>
        </Drawer>
        <!-- Drawer -->
        <Drawer v-model="drawerModal" :title="drawerTitle" width="80">
            <div v-if="drawerId == 2">
                <Form :model="formData" label-position="right" :label-width="100">
                    <div class="drawer_header">
                        <img  class="width_height_24 mr-12" src="../../assets/information.png">
                        <div style="color: #FF761D;">为了简化操作，如果小箱已装过大箱，执行该操作，小箱会重新绑定到新的大箱码中。（当需要拆箱重新分箱装货的场景时，免除了拆箱操作）</div>
                    </div>
                    <FormItem label="录入大箱码：">
                        <div class="display_flex">
                            <Input class="width_30 mr-24" search v-model="formData.big_box_number" enter-button="随机生成" placeholder="录入已有外箱码或随机生成一个外箱码" @on-search="getPackingCountRound"/>
                            <Tooltip max-width="250" placement="right" theme="light">
                                <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                                <div slot="content"><p>推荐提前印好箱码，然后扫码装箱关联。</p></div>
                            </Tooltip>
                        </div>
                    </FormItem>
                    <FormItem label="录入小箱码：">
                        <Input class="width_30 mr-24" type="textarea" v-model="qrcode_number" :autosize="{minRows: 10}" placeholder="一行一个，支持手工录入和扫码枪扫码录入"></Input>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                            <div slot="content"><p>支持手动和扫码枪扫码录入。</p></div>
                        </Tooltip>
                    </FormItem>
                    <div class="ta-r">
                        <Button class="theme-bg" type="warning" @click="submitDrawer">确定装箱</Button>
                    </div>
                </Form>
            </div>
            <div v-if="drawerId == 3">
                <Form :model="formData" label-position="right" :label-width="100">
                    <div class="drawer_header">
                        <img  class="width_height_24 mr-12" src="../../assets/information.png">
                        <div style="color: #FF761D;">为了简化操作，如果小箱已装过大箱，执行该操作，小箱会重新绑定到新的大箱码中。（当需要拆箱重新分箱装货的场景时，免除了拆箱操作） </div>
                    </div>
                    <FormItem label="录入大箱码：">
                        <div class="display_flex">
                            <Input class="width_30 mr-24" type="text" v-model="formData.big_box_number" placeholder="录入已有大箱码"/>
                            <Tooltip max-width="250" placement="right" theme="light">
                                <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                                <div slot="content"><p>支持手工录入和扫码枪扫码录入。</p></div>
                            </Tooltip>
                        </div>
                    </FormItem>
                    <FormItem label="录入小箱码：">
                        <Input class="width_30 mr-24" type="textarea" v-model="qrcode_number" :autosize="{minRows: 10}" placeholder="录入产品上的溯源码编码， 一行一个，支持手工录入和扫码枪扫码录入"></Input>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                            <div slot="content"><p>支持手动和扫码枪扫码录入。</p></div>
                        </Tooltip>
                    </FormItem>
                    <div class="ta-r">
                        <Button class="theme-bg" type="warning" @click="submitDrawer">确定装箱</Button>
                    </div>
                </Form>
            </div>
            <div v-if="drawerId == 4">
                <Form :model="formData" label-position="right" :label-width="100">
                    <FormItem label="录入小箱码：">
                        <Input class="width_30 mr-24" type="textarea" v-model="qrcode_number" :autosize="{minRows: 10}" placeholder="录入要移出大箱的小箱码 一行一个，支持手工录入和扫码枪扫码录入"></Input>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                            <div slot="content"><p>支持手动和扫码枪扫码录入。</p></div>
                        </Tooltip>
                    </FormItem>
                    <div class="ta-r">
                        <Button class="mr-24" @click="cancelDrawer">取消</Button>
                        <Button class="theme-bg" type="warning" @click="submitDrawer">确定</Button>
                    </div>
                </Form>
            </div>
        </Drawer>
    </div>
</template>

<script>
import { 
    packing_big_list, 
    packing_big_delete, 
    packing_big_tostart, 
    packing_count_round, 
    packing_big_small, 
    packing_big_product,
} from '@/api/index';
import { batch_select, product_select, } from '@/api/select';
export default {
    data() {
        return {
            qrcode_number: "",
            big_box_number: "",
            storePrams: {
                page: 1,
                limit: 10,
                qrcode_number: "",
                batch_id: "",
                small_box_number: "",
                big_box_number: "",
                product_id: "",
            },
            total: 0,
            columnsTable: [
                { type: 'selection', width: 60, align: 'center' },
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "大箱码编码", key: "big_box_number", align: "center" },
                { title: "箱内小箱数量", slot: "small_num", align: "center" },
                { title: "箱内产品数量", slot: "product_nums", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataTable: [],
            batchList: [],
            productList: [],
            drawerModal: false,
            drawerTitle: "",
            drawerId: 0,
            detailsDrawer: false,
            detailsTitle: "",
            pageDetails: {
                page: 1,
                limit: 10,
                big_box_number: "",
            },
            totalDetails: 0,
            columnsDetails: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "小箱码", slot: "small_box_number", align: "center" },
                { title: "箱内产品数量", slot: "count", align: "center" },
            ],
            dataDetails: [],
            // selection
            del_id: "",
            delData: [],
            del_value: false,
            formData: {
                qrcode_number: [],
                big_box_number: "",
                is_round: 0,
                is_exist: 0,
            },
            productDrawer: false,
            productTitle: "",
            pageProduct: {
                page: 1,
                limit: 10,
                big_box_number: "",
            },
            totalProduct: 0,
            columnsProduct: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "图片", slot: "show_product_imgs", align: "center" },
                { title: "产品名称", slot: "product_name", align: "center" },
                { title: "规格", slot: "specs", align: "center" },
                { title: "产品编码", key: "qrcode_number", align: "center" },
            ],
            dataProduct: [],
        };
    },
    mounted() {
        this.getList();
        this.getBatchSelect();
        this.getProductSelect();
    },
    methods: {
        getList() {
            packing_big_list(this.storePrams).then((res) => {
                this.dataTable = res.data;
                this.total = res.data.length;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 大箱中小箱列表
        getPackingBigSmall(){
            packing_big_small(this.pageDetails).then((res) => {
                this.dataDetails = res.data.data;
                this.totalDetails = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 大箱中产品列表
        getPackingBigProduct(){
            packing_big_product(this.pageProduct).then((res) => {
                this.dataProduct = res.data.data;
                this.totalProduct = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 批次下拉
        getBatchSelect(){
            batch_select().then((res) => {
                this.batchList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 产品下拉
        getProductSelect(){
            product_select().then((res) => {
                this.productList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        changeDetails(index){
            this.pageDetails.page = index;
        },
        changeProduct(index){
            this.pageProduct.page = index;
        },
        goSearch() {
            this.getList();
        },
        goDetails(row){
            this.big_box_number = row.big_box_number;
            this.pageDetails.big_box_number = row.big_box_number;
            this.getPackingBigSmall();
            this.detailsTitle = this.big_box_number + '大箱详情';
            setTimeout(() => {
                this.detailsDrawer = true;
            }, 300);
        },
        goProduct(row){
            this.big_box_number = row.big_box_number;
            this.pageProduct.big_box_number = row.big_box_number;
            this.getPackingBigProduct();
            this.productTitle = this.big_box_number + '大箱详情';
            setTimeout(() => {
                this.productDrawer = true;
            }, 300);
        },
        goPacking(){
            this.formData.is_exist = 0;
            this.formData.qrcode_number = [];
            this.formData.big_box_number = "";
            this.formData.is_round = 0;
            this.qrcode_number = "";
            this.drawerTitle = "小箱装入大箱";
            this.drawerId = 2;
            this.drawerModal = true;
        },
        goRepair(){
            this.formData.is_exist = 0;
            this.formData.qrcode_number = [];
            this.formData.big_box_number = "";
            this.formData.is_round = 0;
            this.qrcode_number = "";
            this.drawerTitle = "补充小箱到大箱";
            this.drawerId = 3;
            this.drawerModal = true;
        },
        goUnpacking(){
            this.formData.qrcode_number = [];
            this.qrcode_number = "";
            this.drawerTitle = "拆码出箱(拆大箱操作)";
            this.drawerId = 4;
            this.drawerModal = true;
        },
        goDel(index, row){
            if(index == 0 && this.delData.length == 0){
                this.$Message.error('请选择');
                return
            }
            let that = this;
            this.$Modal.confirm({
                title: '是否确定取消该大箱？',
                content: '取消该大箱将解除大箱内的小箱绑定。',
                onOk: () => {
                    if(index == 0){
                        var del_id = [];
                        this.delData.forEach(item => {
                            del_id.push(item.big_box_number)
                        });
                        this.del_id = del_id.join(',');
                        packing_big_delete({ big_box_number: this.del_id }).then(res=>{
                            that.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }else if(index == 1){
                        packing_big_delete({ big_box_number:row.big_box_number }).then(res=>{
                            that.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }
                },
                onCancel: () => {
                }
            }); 
        },
        // selection
        changeSelection(e){
            this.delData = e;
            if(this.dataTable.length === e.length){
                this.del_value = true;
            }else{
                this.del_value = false;
            }
        },
        handleSelectAll(e){
            if(e == true){
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            }else{
                this.$refs.selection.selectAll(false);
            }
        },
        getPackingCountRound(){
            this.formData.is_round = 1;
            packing_count_round().then( res => {
                this.formData.big_box_number = res.data;
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        // 确定
        submitDrawer(){
            if(this.qrcode_number){
                this.formData.qrcode_number = this.qrcode_number.split('\n').map((item, index) => {
                    if (item === '') {
                        // 如果是空字符串，表示这里有一个换行
                        return null;
                    }
                    return item;
                });
            }
            if(this.drawerId == 4){
                packing_unpack({small_box_number: this.formData.qrcode_number}).then( res => {
                    this.getList();
                    this.drawerModal = false;
                    this.$Message.success(res.msg);
                }).catch(res=>{
                    this.$Message.error(res.msg);
                }) 
                return
            }
            this.formData.qrcode_number = this.formData.qrcode_number.filter(item => item != null);
            packing_big_tostart(this.formData).then( res => {
                this.getList();
                this.drawerModal = false;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        cancelDrawer(){
            this.drawerModal = false;
        }
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.drawer_header {
    margin-bottom: 12px;
    padding: 24px;
    display: flex;
    align-items: center;
}
.width_height_24{
    width: 24px;
    height: 24px;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.page {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.page_drawer {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.table_img {
    margin: 12px 0;
    width: 60px;
    height: 60px;
    border-radius: 5px;
}
::v-deep .ivu-input-search {
    background: #53C41A !important;
    border-color: #53C41A !important;
}
::v-deep .ivu-checkbox{
    margin-right: 24px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.display_flex {
    display: flex;
}
.width_30 {
    width: 30vw;
}
</style>